import React, { createContext, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { translations } from "@/i18n/content";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const { lang: rawLang } = useParams();
  const lang = rawLang === "en" ? "en" : "fr";

  useEffect(() => {
    try {
      localStorage.setItem("nek-lang", lang);
    } catch (error) {
      console.warn("Unable to persist language preference:", error);
    }
  }, [lang]);

  const t = translations[lang];
  const value = {
    lang,
    other: lang === "fr" ? "en" : "fr",
    t,
    // Build a localized path: to("/contact") -> "/fr/contact"
    to: (sub = "") => `/${lang}${sub}`,
    // Switch to the other language while keeping the current sub-path.
    swapLangPath: (currentPathname) => {
      const target = lang === "fr" ? "en" : "fr";
      const parts = currentPathname.split("/").filter(Boolean);
      parts[0] = target;
      return "/" + parts.join("/");
    },
  };

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}

export function getStoredLang() {
  try {
    const v = localStorage.getItem("nek-lang");
    return v === "en" ? "en" : "fr";
  } catch (e) {
    return "fr";
  }
}
